import styled from 'styled-components/macro'

export const LogoWrapper = styled.div`
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
`

export type LogoProps = {
  url?: string
}

export function Logo({ url }: LogoProps) {
  if (!url) return null

  return (
    <LogoWrapper>
      <img src={url} alt="" loading="lazy" />
    </LogoWrapper>
  )
}
